import { Button, Modal, ModalInner } from 'components';
import { ScheduleGridData } from './types';
import { Dispatch, SetStateAction, useEffect } from 'react';
import axios from 'common/AxiosAuth';

// ✨ 1. Props의 any 타입을 명확하게 수정하여 타입 안정성 강화
interface ModalProps {
  data: ScheduleGridData | null;
  setData: Dispatch<SetStateAction<ScheduleGridData | null>>;
  onDeleted: () => void;
  setIsDeleteModalOpened: Dispatch<SetStateAction<boolean>>;
}

const DeleteModal = ({ data, setData, onDeleted, setIsDeleteModalOpened }: ModalProps) => {

  const onDelete = async () => {
    // 데이터 유효성 검증
    if (!data?.orderId) {
      alert('잘못된 예약 정보입니다.');
      return;
    }

    try {
      if (data.paymentKey) {
        // --- 1. 토스 결제 취소 API 호출 ---
        console.log(`[Toss결제 취소] API: /api/confirm/cancel/toss, paymentKey: ${data.paymentKey}`);
        
        await axios.patch(`/api/confirm/cancel/toss`, { 
            paymentKey: data.paymentKey,
            orderId: data.orderId,
            cancelReason: '고객 요청'
        });

      } else {
        // --- 2. 일반 결제(계좌이체) 취소 API 호출 ---
        console.log(`[일반결제 취소] API: /api/confirm/cancel/bank, orderId: ${data.orderId}`);

        await axios.patch(`/api/confirm/cancel/bank`, {
            orderId: data.orderId,
            cancelReason: '고객 요청'
        });
      }

      setData(null);
      setIsDeleteModalOpened(false);
      onDeleted(); // 부모 컴포넌트에 취소 성공 사실 알림 (데이터 재조회 등)

    } catch (error) {
      console.error('취소 중 에러:', error);
      alert('취소에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const onCancel = () => {
    setIsDeleteModalOpened(false);
    setData(null);
  };

  if (!data) return null;

  return (
    <Modal isOpened={true}>
      <ModalInner className="md:w-[400px]" title="Cancel Schedule" onClickClose={onCancel}>
        <p className="p-4 pt-0 text-body1">
          Are you sure you want to delete your schedule?<br />This operation cannot be undone.
        </p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Close" onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9 bg-red-600 border-red-600" text="Cancel" onClick={onDelete} size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteModal;